import { render, staticRenderFns } from "./CampaignWAFilter.vue?vue&type=template&id=95c546ce&scoped=true&"
import script from "./CampaignWAFilter.vue?vue&type=script&lang=js&"
export * from "./CampaignWAFilter.vue?vue&type=script&lang=js&"
import style0 from "./CampaignWAFilter.vue?vue&type=style&index=0&id=95c546ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95c546ce",
  null
  
)

export default component.exports